<template>
  <div>
    <el-progress v-if="showProgressBar" :percentage="state.percentage" />

    <p class="section-summary">
      {{ state.doneFields.length }} out of {{ fields.length }} fields are
      completed
    </p>
    <p>Here are fields that are still empty:</p>

    <div class="section-fields">
      <div
        v-for="field in doneLast(fields)"
        :key="field.name"
        class="section-field"
        :class="{ 'is-done': field.done }"
      >
        <ion-icon name="ios-arrow-forward" class="field-arrow" />
        <span class="field-label">{{ field.label }}</span>
        <ion-icon v-if="field.done" name="checkmark" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from '@vue/composition-api'
import { sortBy, isNumber } from 'lodash'

export default {
  props: {
    title: String,
    fields: Array,
    showProgressBar: { type: Boolean, default: false },
  },
  setup(props) {
    const doneFields = computed(() => {
      return props.fields.filter((f) => f.done)
    })
    const undoneFields = computed(() => {
      return props.fields.filter((f) => !f.done)
    })
    const state = reactive({
      doneFields,
      undoneFields,
      percentage: computed(() => {
        if (props.fields.length === 0) {
          return 0
        } else {
          const result = (state.doneFields.length / props.fields.length) * 100
          return parseInt(result)
        }
      }),
    })
    return {
      state,
      doneLast(fields) {
        return sortBy(props.fields, 'done')
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/colors.scss';

.section-fields {
  .section-field {
    &.is-done {
      color: $grey150;
    }
  }
}
</style>
